<template>
    <div>
        <div :class="modalClass" @click.stop="() => { if (dismissible) $emit('update:show', false) }">
            <div :class="contentClass" @click.stop="">
                <div :class="headerClass" v-if="title || dismissible || withHeader">
                    <h3 class="modal-title" v-if="title">{{ title }}</h3>
                    <button :class="closeButtonClass" type="button" @click.stop="$emit('update:show', false)" v-if="dismissible"><span class="mdi mdi-close"></span></button>
                </div>
                <div :class="bodyClass"><slot/></div>
                <div class="modal-footer" v-if="!!$slots.footer || withFooter"><slot name="footer"/></div>
            </div>
        </div>
        <div class="modal-overlay"></div>
    </div>
</template>

<script>
    export default {
        props: {
            show: Boolean,
            effect: [Number, String],
            dismissible: Boolean,
            headerColor: String,
            fullWidth: Boolean,
            bodyContrast: Boolean,
            fullColor: String,
            title: String,
            withHeader: Boolean,
            withFooter: Boolean,
        },

        computed: {
            modalClass() {
                return {
                    'modal-container': true,
                    'modal-show': this.show,
                    [`modal-effect-${this.effect}`]: !!this.effect,
                    'colored-header': !!this.headerColor,
                    [`colored-header-${this.headerColor}`]: !!this.headerColor,
                    'modal-full-color': !!this.fullColor,
                    [`modal-full-color-${this.fullColor}`]: !!this.fullColor,
                    'full-width': this.fullWidth,
                };
            },

            contentClass() {
                return {
                    'modal-content': true,
                    'full-width': this.fullWidth,
                };
            },

            headerClass() {
                return {
                    'modal-header': true,
                    'modal-header-colored': !!this.headerColor,
                };
            },

            bodyClass() {
                return {
                    'modal-body': true,
                    'card-body-contrast': this.bodyContrast,
                };
            },

            closeButtonClass() {
                return {
                    'close modal-close': true,
                    'text-white': !!this.headerColor || !!this.fullColor,
                };
            },
        },

        watch: {
            show(value) {
                if (value) {
                    document.documentElement.classList.add('be-modal-open');
                    document.body.classList.add('modal-open');
                } else {
                    document.documentElement.classList.remove('be-modal-open');
                    document.body.classList.remove('modal-open');
                }
            },
        },

        destroyed() {
            document.documentElement.classList.remove('be-modal-open');
            document.body.classList.remove('modal-open');
        },
    };
</script>
